/**
 * <Stat> — single tile used by the AutoReconcile review phase header.
 */
import React from 'react';

const ACCENT_COLOUR = {
  emerald: 'text-[#059669]',
  amber: 'text-[#B45309]',
};

const Stat = ({ label, value, accent }) => {
  const colour = ACCENT_COLOUR[accent] || 'text-[#020617]';
  return (
    <div className="rounded-lg border border-[#E2E8F0] bg-[#F8FAFC] py-3">
      <div className={`text-2xl font-extrabold ${colour}`}>{value}</div>
      <div className="text-[10px] uppercase tracking-wider text-[#64748B]">{label}</div>
    </div>
  );
};

export default Stat;
